const DEFAULT_TTL_MS = 2 * 60 * 1000;
const snapshotCache = new Map();

export const buildSnapshotCacheKey = (reportId, version) => `${String(reportId)}::${String(version)}`;

export function getSnapshotCache(reportId, version, options = {}) {
    if (!reportId || !version) return null;

    const ttlMs = Number.isFinite(options.ttlMs) ? options.ttlMs : DEFAULT_TTL_MS;
    const now = Date.now();
    const key = buildSnapshotCacheKey(reportId, version);
    const cached = snapshotCache.get(key);

    if (!cached) return null;

    if (ttlMs > 0 && now - cached.cachedAt > ttlMs) {
        snapshotCache.delete(key);
        return null;
    }

    return cached.payload || null;
}

export function setSnapshotCache(reportId, version, payload, options = {}) {
    if (!reportId || !version || !payload) return;

    const key = buildSnapshotCacheKey(reportId, version);
    snapshotCache.set(key, {
        reportId: String(reportId),
        version: String(version),
        payload,
        cachedAt: options.cachedAt || Date.now(),
    });
}

export function invalidateSnapshotCache(reportId, version) {
    if (reportId && version) {
        snapshotCache.delete(buildSnapshotCacheKey(reportId, version));
        return;
    }

    if (reportId && !version) {
        const reportPrefix = `${String(reportId)}::`;
        Array.from(snapshotCache.keys()).forEach((key) => {
            if (key.startsWith(reportPrefix)) snapshotCache.delete(key);
        });
        return;
    }

    snapshotCache.clear();
}

